import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../constants/actionTypes';
import { MOBILE_WINDOW_BREAKPOINT } from '../../constants/constants';
import Routes from '../../constants/routes';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Dropdown } from 'primereact/dropdown';
import Icon from '../Common/Icon';
import Notification from '../Common/Notification';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import { Menu } from 'primereact/menu';
import BaselineForm from '../Subscription/Admin/BaselinesForm';
import LinkProjectBaselineDrawer from './LinkProjectBaselineDrawer';

const ACTION_MENU_OPTIONS = {
	OpenBaseline: 'openBaseline',
	CopyBaseline: 'copyBaseline',
	EditBaseline: 'editBaseline',
};

export class ProjectBaselines extends React.Component {
	constructor(props, context) {
		super(props, context);

		const newBaseline = {
			id: 0,
			name: '',
			description: '',
			isActive: true,
			subscriptionId: props.subscriptionId,
			users: [],
		};

		this.state = {
			baselines: [],
			users: [],
			totalCount: 0,
			isLoading: false,
			selectedBaseline: newBaseline,
			editBaseline: newBaseline,
			newBaseline: newBaseline,
			isAddNewDrawerOpen: false,
			isLinkExistingDrawerOpen: false,
			editAction: '',
			searchParams: {
				subscriptionId: this.props.subscriptionId,
				projectKey: this.props.projectKey,
				isActive: true,
				pageSize: 10, // Smaller default page size for table in section of PM Dashboard
				pageNumber: 1,
				sortBy: 'name',
				sortDir: 'asc',
				name: '',
			},
		};
	}

	async componentDidMount() {
		await this.search();
	}

	componentDidUpdate(prevProps) {
		if (this.props.projectKey !== prevProps.projectKey) {
			this.setState(
				{
					...this.state,
					searchParams: {
						...this.state.searchParams,
						projectKey: this.props.projectKey,
					},
				},
				this.search
			);
		}
	}

	search = async () => {
		try {
			this.setState({ isLoading: true });
			const result = await this.props.projectMgrDashboardActions.loadProjectBaselines(this.state.searchParams);
			const payload = result.payload;
			if (result.type === types.LOAD_PROJECT_BASELINES_SUCCESS) {
				this.setState({ baselines: payload.results, totalCount: payload.totalCount });
			} else if (result.type === types.LOAD_PROJECT_BASELINES_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isLoading: false });
		}
	};

	filterChange = (e) => {
		let name = e.target.name;
		this.setState({ searchParams: { ...this.state.searchParams, [name]: e.target.value } });
	};

	onSearchBlur = () => {
		this.search();
	};
	keyUpFilter = (e) => {
		if (e.keyCode == 13) {
			this.search();
		}
	};

	onActiveChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, isActive: e.value } }, () => {
			this.search();
		});
	};

	onPageChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, pageNumber: e.page + 1 } }, () => {
			this.search();
		});
	};

	onFormChange = (name, value) => {
		this.setState({ editBaseline: { ...this.state.editBaseline, [name]: value } });
	};

	activeTemplate = (rowData) => {
		if (rowData.isActive) {
			return (
				<div className='text-success'>
					<Icon name='check-circle' />
				</div>
			);
		} else {
			return (
				<div className='text-danger'>
					<Icon name='times-circle' />
				</div>
			);
		}
	};

	onActionsClick = (rowData, e) => {
		this.menu.toggle(e);
		this.setState({ selectedBaseline: rowData, editBaseline: rowData });
	};

	actionTemplate = (rowData) => {
		return (
			<div className='text-center ellipsis' onClick={(e) => this.onActionsClick(rowData, e)}>
				<Icon name='ellipsis-h' />
			</div>
		);
	};

	nameTemplate = (rowData) => {
		return <div className='baseline-name'>{rowData.name}</div>;
	};

	menuOptionClick = (e) => {
		switch (e.item.value) {
			case ACTION_MENU_OPTIONS.OpenBaseline: {
				this.openBaseline();
				break;
			}
			case ACTION_MENU_OPTIONS.CopyBaseline: {
				Notification('error', 'Error', 'Copy Baseline Not Implemented Yet');
				break;
			}
			case ACTION_MENU_OPTIONS.EditBaseline: {
				Notification('error', 'Error', 'Edit Baseline Not Implemented Yet');
				break;
			}
		}
	};

	openBaseline = () => {
		this.props.history.push(Routes.BaselineTaskList + '/?bid=' + this.state.selectedBaseline.baselineId);
	};

	onAddNew = () => {
		this.setState({ isAddNewDrawerOpen: true });
	};

	onAddNewComplete = () => {
		this.setState({ isAddNewDrawerOpen: false }, this.search);
	};

	onAddNewCancel = () => {
		this.setState({ isAddNewDrawerOpen: false });
	};

	onLinkExisting = () => {
		this.setState({ isLinkExistingDrawerOpen: true });
	};

	onLinkExistingComplete = () => {
		this.setState({ isLinkExistingDrawerOpen: false }, this.search);
	};

	onLinkExistingCancel = () => {
		this.setState({ isLinkExistingDrawerOpen: false });
	};

	selectBaseline = (e) => {
		const isEllipsisClick =
			e.originalEvent.target.className.indexOf('ellipsis-h') >= 0 || e.originalEvent.target.className.indexOf('ellipsis') >= 0;
		if (isEllipsisClick === true) {
			return;
		}

		this.setState({ selectedBaseline: e.value, editBaseline: e.value }, this.openBaseline);
	};

	render() {
		const displayColumns = this.props.windowWidth < MOBILE_WINDOW_BREAKPOINT ? 'none' : '';

		const activeOptions = [
			{ label: 'Yes', value: true },
			{ label: 'No', value: false },
			{ label: 'All', value: null },
		];

		const menuOptions = [
			{ label: 'Open Baseline', value: ACTION_MENU_OPTIONS.OpenBaseline, command: this.menuOptionClick },
			{ label: 'Copy Baseline', value: ACTION_MENU_OPTIONS.CopyBaseline, command: this.menuOptionClick },
			{ label: 'Edit Name or Access', value: ACTION_MENU_OPTIONS.EditBaseline, command: this.menuOptionClick },
		];

		const activeFilter = (
			<Dropdown className='ui-column-filter' value={this.state.searchParams.isActive} options={activeOptions} onChange={this.onActiveChange} />
		);

		const nameFilterElement = (
			<input
				type='text'
				name='name'
				className='p-inputtext'
				placeholder='Filter by Name'
				size='50'
				onBlur={this.onSearchBlur}
				onChange={this.filterChange}
				onKeyUp={this.keyUpFilter}
				value={this.state.searchParams.name}
			/>
		);
		const descriptionFilterElement = (
			<input
				type='text'
				name='description'
				className='p-inputtext'
				placeholder='Filter by Description'
				size='50'
				onBlur={this.onSearchBlur}
				onChange={this.filterChange}
				onKeyUp={this.keyUpFilter}
				value={this.state.searchParams.description}
			/>
		);
		return (
			<div className='project-baselines-section'>
				<Menu model={menuOptions} popup={true} ref={(el) => (this.menu = el)} />
				{this.state.isAddNewDrawerOpen && (
					<BaselineForm
						baseline={this.state.editBaseline.id}
						saveClick={this.onAddNewComplete}
						cancelClick={this.onAddNewCancel}
						baselineActions={this.props.baselineActions}
						projectKey={this.props.projectKey}
						subscriptionId={this.props.subscriptionId}
					/>
				)}
				{this.state.isLinkExistingDrawerOpen && (
					<LinkProjectBaselineDrawer
						subscriptionId={this.props.subscriptionId}
						projectKey={this.props.projectKey}
						projectMgrDashboardActions={this.props.projectMgrDashboardActions}
						onComplete={this.onLinkExistingComplete}
						onCancel={this.onLinkExistingCancel}
					/>
				)}
				<LoadingIndicator isLoading={this.state.isLoading} hideWhileLoading={true}>
					<div>
						<div className='d-flex justify-content-between align-items-center mb-3' id='project-baselines-table'>
							<h5 className='dashboard-widget-title fw-bold mb-0'>Baselines</h5>
							<div className='d-flex gap-2'>
								<button type='button' className='btn btn-secondary' onClick={this.onLinkExisting} alt='Link Existing'>
									<span className='me-2'>Link Existing</span>
								</button>
								<button type='button' className='btn btn-primary' onClick={this.onAddNew} alt='Add New'>
									<span className='me-2'>Add New</span>
									<Icon name='plus-circle' />
								</button>
							</div>
						</div>
						<div className='identifier-results-table'>
							<DataTable
								filterDisplay='row'
								className='p-datatable-sm p-datatable-striped p-datatable-gridlines'
								value={this.state.baselines}
								selectionMode='single'
								selection={this.state.selectedBaseline}
								onSelectionChange={this.selectBaseline}>
								<Column field='name' header='Name' body={this.nameTemplate} filter={true} filterElement={nameFilterElement} />
								<Column
									field='description'
									header='Description'
									filter={true}
									filterElement={descriptionFilterElement}
									style={{ display: displayColumns }}
								/>
								<Column field='lastTaskDate' header='Last Location Task Date' style={{ display: displayColumns }} />
								<Column
									field='isActive'
									header='Active'
									body={this.activeTemplate}
									style={{ textAlign: 'center', width: '120px' }}
									filter={true}
									filterElement={activeFilter}
								/>
								<Column field='dotdotdot' header='Actions' body={this.actionTemplate} style={{ textAlign: 'center', width: '6em' }} />
							</DataTable>
							{this.state.totalCount > this.state.searchParams.pageSize && (
								<Paginator
									rows={this.state.searchParams.pageSize}
									totalRecords={this.state.totalCount}
									first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
									onPageChange={this.onPageChange}
								/>
							)}
							<div className='results-count mt-2'>Total records: {this.state.totalCount}</div>
						</div>
					</div>
				</LoadingIndicator>
			</div>
		);
	}
}

ProjectBaselines.propTypes = {
	windowWidth: PropTypes.number.isRequired,
	subscriptionId: PropTypes.string.isRequired,
	projectKey: PropTypes.string.isRequired,
	projectMgrDashboardActions: PropTypes.object.isRequired,
	baselineActions: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
};

export default ProjectBaselines;
